function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var OmanFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_2104",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_2104)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#F50101"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_2104",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_2104)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V9H24V3H0Z",
        fill: "#F7FCFF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 15V21H24V15H0Z",
        fill: "#5EAA22"
      }), /*#__PURE__*/_jsx("rect", {
        y: "3",
        width: "9",
        height: "18",
        fill: "#F50101"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.08664 4.43327C8.09069 4.3876 8.03205 4.36981 8.00906 4.40949C7.77453 4.81433 7.07889 5.96076 5.88524 7.48959V6.80135C5.77813 6.68494 5.43665 6.37175 5.43665 6.37175V5.68451L6.05441 5.12547L5.20596 4.50001L4.3117 5.12547L4.98764 5.68451V6.37175C4.98764 6.7013 4.57784 6.80135 4.57784 6.80135L4.50281 7.40756C3.38629 5.95772 2.71907 4.84921 2.47937 4.43132C2.45594 4.39047 2.39534 4.40889 2.40165 4.45556C2.46799 4.94586 2.70219 6.24927 3.43637 7.6473H3.25193V8.09533H3.45106C3.51861 8.25113 3.67377 8.36095 3.85523 8.36412C3.98197 8.55967 4.11942 8.75468 4.26846 8.94725C3.92561 8.91334 1.65958 8.72041 1.65958 9.5448C1.65958 10.0369 2.21073 10.2973 2.90195 10.432C2.15601 11.1075 1.45493 11.7402 1.18729 11.9816C1.1546 12.0111 1.18133 12.0615 1.22419 12.0513C1.69469 11.9401 3.18572 11.5336 4.60164 10.5676L4.64361 10.5677C5.02294 10.5677 5.28676 10.4031 5.47013 10.1804C6.92414 11.3672 8.58083 11.8762 9.17632 12.0304C9.22304 12.0426 9.24881 11.9824 9.20892 11.9552C8.72536 11.626 7.41449 10.6823 6.07212 9.26966L6.10517 9.23096C6.36221 8.92763 6.58618 8.61563 6.78133 8.30279C6.86303 8.25502 6.92809 8.18235 6.96582 8.09533H7.16495V7.6473H7.15022L7.16497 7.61799V8.63924C7.16497 8.66325 7.18444 8.68272 7.20845 8.68272H8.83345C8.85746 8.68272 8.87693 8.66325 8.87693 8.63924V7.6012C8.87693 7.57718 8.85746 7.55772 8.83345 7.55772H7.20845C7.20324 7.55772 7.19823 7.55864 7.1936 7.56032C7.87549 6.17379 8.04564 4.89567 8.08664 4.43327ZM1.53995 7.6012C1.53995 7.57718 1.55941 7.55772 1.58343 7.55772H3.20843C3.23244 7.55772 3.2519 7.57718 3.2519 7.6012V8.63924C3.2519 8.66325 3.23244 8.68272 3.20843 8.68272H1.58343C1.55941 8.68272 1.53995 8.66325 1.53995 8.63924V7.6012ZM4.23018 7.92062C4.23018 8.12105 4.06594 8.28352 3.86333 8.28352C3.66073 8.28352 3.49649 8.12105 3.49649 7.92062C3.49649 7.7202 3.66073 7.55772 3.86333 7.55772C4.06594 7.55772 4.23018 7.7202 4.23018 7.92062ZM6.1867 7.92062C6.1867 8.12105 6.35094 8.28352 6.55354 8.28352C6.75615 8.28352 6.92039 8.12105 6.92039 7.92062C6.92039 7.7202 6.75615 7.55772 6.55354 7.55772C6.35094 7.55772 6.1867 7.7202 6.1867 7.92062Z",
        fill: "#F7FCFF"
      })]
    })]
  })]
}));
//# sourceMappingURL=Oman.js.map